import { Indicator, IndicatorProps } from '@mantine/core';

import classes from './Indicator.module.css';

const IndicatorDefaults = Indicator.extend({
  defaultProps: {
    size: 16,
  },
  classNames: {
    indicator: classes.indicator,
  },
});

export { Indicator, IndicatorDefaults };
export type { IndicatorProps };
